import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'post'

export default class OspreyTemplatesCreate extends BaseAction {
    constructor(dataKey) {
        const id = '55c7e357-403e-49fe-a01e-f91a76e50faf'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    create(params) {
        this.path = `/${resource}`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-create.js